import type { ReactNode, Ref } from "react";

import FileUploadControl from "./FileUploadControl";

/** Arriba de los datos del jugador: «Sube su CURP y llenamos sus datos».
 * La lectura (parse-curp) y la revisión las hace la página; aquí solo va el
 * selector, el estado y el aviso que toque (`children`). */
export default function PlayerCurpStep({
  title,
  inputId,
  file,
  parsing,
  message,
  multiple,
  onFile,
  inputRef,
  children,
}: {
  title: string;
  inputId: string;
  file: File | null | undefined;
  parsing: boolean;
  /** Mensaje del servidor cuando no hay aviso que atender. */
  message: string | null;
  /** El PDF trae varias CURP. */
  multiple: boolean;
  onFile: (file: File | null) => void;
  inputRef?: Ref<HTMLInputElement>;
  children?: ReactNode;
}) {
  return (
    <section className="public-registration-documents public-registration-curp-autofill" aria-labelledby={`${inputId}-title`}>
      <h3 className="public-registration-documents__title" id={`${inputId}-title`}>{title}</h3>
      <label className="public-registration-field">
        <span>CURP en PDF</span>
        <FileUploadControl id={inputId} accept="application/pdf" file={file} onChange={onFile} inputRef={inputRef} />
      </label>
      {parsing ? <p className="public-registration-parser-status" role="status">Leyendo CURP…</p> : null}
      {multiple ? <p className="public-registration-parser-status is-warning">Este PDF trae varias CURP; sube solo la del jugador.</p> : null}
      {message ? <p className="public-registration-parser-status is-success">{message}</p> : null}
      {children}
    </section>
  );
}
